module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av577-43877018211475d5128b316ecf1790e2.jpg";